
export type GetCoursesFilterByLevel = typeof GetCoursesFilterByLevel[keyof typeof GetCoursesFilterByLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCoursesFilterByLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
